<template>
  <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{category_id ? 'Update' : 'Create'}} Category</p>
      </header>
      <div class="modal-card-body">
        <!--Loading-->
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <b-field label="Name">
          <b-input
            v-model="category.name"
            ref="title"
            minlength="3"
            required
            type="text"
            placeholder="Add category name here"
          ></b-input>
        </b-field>
          
        <div class="columns">
          <div class="column">
            <b-field label="Order">
              <b-numberinput
                ref="order"
                step="0.1"
                :controls="false"
                v-model="category.order"
                placeholder="Add your order here"
              ></b-numberinput>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Parent">
              <treeselect
                :multiple="false"
                :options="fetchCategories"
                :normalizer="$common.normalizer"
                :defaultExpandLevel="Infinity"
                value-consists-of="ALL"
                placeholder="Select Category/Subcategory *"
                v-model="category.parent"
              >
              </treeselect>
            </b-field>
          </div>
        </div>
        
        <b-field label="Remarks">
          <b-input
            ref="remarks"
            v-model="category.remarks"
            type="textarea"
            placeholder="Add any remarks"
          ></b-input>
        </b-field>
        <b-field label="Status">
          <b-switch
            v-model="category.status"
            type="is-success"
          >{{category.status ? 'Active' : 'Non-Active'}}</b-switch>
        </b-field>
        <b-field label="Not Allow Attempt">
          <b-switch
            v-model="category.is_not_allowed"
            type="is-success"
          >{{category.is_not_allowed ? 'Active' : 'Non-Active'}}</b-switch>
        </b-field>
        
        <button
          type="button"
          @click.prevent="proceed()"
          class="button is-success btn-center"
        >{{category_id ? 'Update' : 'Create'}}</button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-category",
  data() {
    return {
      isLoading: false,
      category : {
        name: "",
        order : null,
        parent: null,
        grade_subject : null,
        remarks : "",
        status : true,
        is_not_allowed : false,
      }
    };
  },
  props: {
    category_id: {
      type: String,
      default: null,
    },
    grade_subject_id : {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchCurrentCategory", "fetchCategories"]),
  },
  methods: {
    ...mapActions([
      "createCategory",
      "updateCategory",
      "loadCategoryDetails",
      "loadCategories"
    ]),
    deleteExistingFile(index) {
      this.editfiles[index].is_deleted = true;
    },
    proceed() {
      let is_validate = this.$refs.title.checkHtml5Validity()
      this.category.grade_subject = this.grade_subject_id
      if (is_validate) {
        this.isLoading = true;
        if (this.category_id) {
          //For editing a category
          this.updateCategory({
            id: this.category_id,
            category: this.category,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Category updated successfully",
              type: "is-success",
            });

            window.location = window.location.href
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        } else {
          //For creating a new category
          this.createCategory({
            category: this.category,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Category created successfully",
              type: "is-success",
            });

          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        }
      }
    },
  },
  async created() {
    if (this.category_id) {
      this.isLoading = true;

      this.loadCategories({
        token : this.getTeacherToken,
        filter : {
          grade_subject : this.grade_subject_id,
          tree : true
        }
      })
      
      await this.loadCategoryDetails({
        id: this.category_id,
        token: this.getTeacherToken,
      });

      for(let key in this.category){
        this.category[key] = this.fetchCurrentCategory[key]
      }
      // this.editfiles = this.fetchCurrentCategory.files.map((file_name) => {
      //   return {
      //     name: this.$common.fileBasename(file_name),
      //     is_deleted: false,
      //   }
      // })
      this.isLoading = false;
    }
  },
};
</script>
<style scoped>
</style>